// extracted by mini-css-extract-plugin
module.exports = {"input":"nDigitInput_input__2hB2l","inputN":"nDigitInput_inputN__3wMRY","container":"nDigitInput_container__3caNp"};